module.exports = __webpack_public_path__ + "media/customizations/sunbridge/back-78c6b82d0d9cdad62ea1da2613291acb.jpg";